<app-modal-basic #modal [hideHeader]="true" [hideFooter]="true" [allowClickOutside]="false"
  (closed)="onClose()" dialogClass="modal-dialog-centered">
  <div class="app-modal-body">
    <div class="text-center">
      <img src="/assets/images/logo-stone.png" style="width: 100px">
    </div>
    <hr>

    <div class="text-center my-4" [ngSwitch]="loadingStone">
      <div *ngSwitchCase="'ENVIANDO_PEDIDO'">
        <h1><i class="fa fa-circle-notch fa-spin"></i></h1>
        <h4>Gerando cobrança, aguarde...</h4>
      </div>
      <div *ngSwitchCase="'AGUARDANDO_PAGAMENTO'">
        <h1><i class="fa fa-circle-notch fa-spin"></i></h1>
        <h4>Aguardando pagamento...</h4>
      </div>
      <div *ngSwitchCase="'CANCELANDO_PEDIDO'">
        <h1><i class="fa fa-circle-notch fa-spin"></i></h1>
        <h4>Cancelando cobrança...</h4>
      </div>
      <div *ngSwitchCase="'PAGAMENTO_CONFIRMADO'">
        <h1><i class="fa-solid fa-check text-success"></i></h1>
        <h4>Pagamento confirmado!</h4>
        <p>Essa janela será fechada automaticamente em 5 segundos...</p>
      </div>
      <div *ngSwitchCase="'FALHA'">
        <h1><i class="fa-solid fa-triangle-exclamation text-danger"></i></h1>
        <h4>Falha no pagamento.</h4>
        <p>{{ mensagemErro }}</p>
      </div>
    </div>

    <div class="space-between" *ngIf="loadingStone === 'AGUARDANDO_PAGAMENTO'">
      <hr>
      <button class="btn btn-info" (click)="continuarSemPagamento()" [disabled]="loading['continuarSemPagamento']">
        Adicionar recebimento sem confirmar
      </button>
      <button class="btn btn-danger float-right" (click)="cancelarPagamento()" [disabled]="loading['continuarSemPagamento']">
        <i class="fa fa-warning"></i>
        Cancelar
      </button>
    </div>

    <div class="space-between" *ngIf="loadingStone === 'PAGAMENTO_CONFIRMADO'">
      <hr>
      <button class="btn btn-info" (click)="fechar(true)">
        Fechar
      </button>
    </div>

    <div class="space-between" *ngIf="loadingStone === 'FALHA'">
      <hr>
      <button class="btn btn-info" (click)="continuarSemPagamento()" [disabled]="loading['continuarSemPagamento']">
        Adicionar recebimento mesmo assim
      </button>
      <button class="btn btn-info float-right" (click)="fechar(false)">
        Fechar
      </button>
    </div>
  </div>
</app-modal-basic>
